import { Bouchon } from "./Bouchon";

type Props = {
  size?: number;
  showWord?: boolean;
  className?: string;
};

/** Logo — Bouchon mark + wordmark lockup. */
export function Logo({ size = 28, showWord = true, className }: Props) {
  return (
    <div className={`inline-flex items-center gap-2.5 ${className ?? ""}`}>
      <Bouchon size={size} glow={false} />
      {showWord && (
        <span
          className="display"
          style={{
            fontSize: size * 0.85,
            color: "var(--color-text)",
            fontWeight: 700,
          }}
        >
          Boulium
        </span>
      )}
    </div>
  );
}
